module.exports = __webpack_public_path__ + "img/echope.dcad2755.png";